import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getPrivateRouteByRole } from "../utils/authUser";
import { clearStoredSession, HOME_ROUTE, isTokenValid, markSessionExpired } from "../utils/session";

const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const hasValidSession = isTokenValid(token);
  const { requiresTratamientoDatos, user } = useAuth();

  if (!hasValidSession) {
    if (token) {
      clearStoredSession();
      markSessionExpired();
    }
    return <Navigate to={HOME_ROUTE} replace />;
  }

  if (requiresTratamientoDatos) {
    return null;
  }

  if (allowedRoles && !allowedRoles.includes(String(user?.idRol))) {
    return <Navigate to={getPrivateRouteByRole(user?.idRol)} replace />;
  }

  return children;
};

export default PrivateRoute;
